(function () {
  var userOpenedWidget = false;
  var suppressedElements = [];
  var candidates = new Set();
  var pendingRoots = new Set();
  var scheduledFrame = null;
  var closingInbox = false;
  var retryTimers = [];
  var launcherSelector = [
    '#ShopifyChat',
    '#smile-ui-lite-launcher-frame-container',
    '#smile-lite-launcher-frame',
    'salesmartly-chat-widget',
    '[id*="smile" i]',
    '[class*="smile" i]',
    '[id*="salesmartly" i]',
    '[class*="salesmartly" i]',
    '[src*="salesmartly" i]',
    '[id*="shopify-chat" i]',
    '[class*="shopify-chat" i]'
  ].join(',');
  var candidateSelector = [
    launcherSelector,
    '[id*="chat" i]',
    '[class*="chat" i]',
    '[id*="inbox" i]',
    '[class*="inbox" i]',
    '[id*="loyalty" i]',
    '[class*="loyalty" i]',
    '[id*="reward" i]',
    '[class*="reward" i]',
    '[title*="chat" i]',
    '[aria-label*="chat" i]',
    '[src*="smile" i]',
    '[src*="shopify-chat" i]',
    '[style*="position" i]',
    '[style*="z-index" i]',
    '[role="dialog"]',
    '[role="complementary"]',
    'body > div',
    'body > aside',
    'body > iframe'
  ].join(',');
  var ignoredSelector = [
    '#shopify-pc__banner',
    '#PBarNextFrameWrapper',
    '#PBarNextFrame',
    '[id*="cookie" i]',
    '[class*="cookie" i]',
    '[id*="privacy" i]',
    '[class*="privacy" i]',
    '[class*="cart" i]',
    '[id*="cart" i]',
    '[aria-modal="true"]'
  ].join(',');

  function getPath(event) {
    if (event.composedPath) {
      return event.composedPath();
    }

    var path = [];
    var node = event.target;

    while (node) {
      path.push(node);
      node = node.parentNode || node.host;
    }

    return path;
  }

  function matches(element, selector) {
    return element && element.nodeType === 1 && element.matches(selector);
  }

  function hasIgnoredAncestor(element) {
    var ancestor = element;

    while (ancestor && ancestor.nodeType === 1 && ancestor !== document.body && ancestor !== document.documentElement) {
      if (matches(ancestor, ignoredSelector)) {
        return true;
      }

      ancestor = ancestor.parentNode;
    }

    return false;
  }

  function markUserOpened(event) {
    if (closingInbox || userOpenedWidget) {
      return;
    }

    var path = getPath(event);

    for (var index = 0; index < path.length; index += 1) {
      if (matches(path[index], launcherSelector)) {
        userOpenedWidget = true;
        observer.disconnect();
        retryTimers.forEach(function (timer) {
          window.clearTimeout(timer);
        });

        if (scheduledFrame !== null) {
          window.cancelAnimationFrame(scheduledFrame);
          scheduledFrame = null;
        }

        pendingRoots.clear();
        candidates.clear();
        document.documentElement.classList.add('chicchok-widget-user-opened');
        restoreSuppressedElements();
        return;
      }
    }
  }

  function restoreSuppressedElements() {
    suppressedElements.forEach(function (entry) {
      if (!entry.element || !entry.element.isConnected) {
        return;
      }

      if (entry.displayPriority) {
        entry.element.style.setProperty('display', entry.displayValue || '', entry.displayPriority);
      } else {
        entry.element.style.display = entry.displayValue || '';
      }

      if (entry.visibilityPriority) {
        entry.element.style.setProperty('visibility', entry.visibilityValue || '', entry.visibilityPriority);
      } else {
        entry.element.style.visibility = entry.visibilityValue || '';
      }

      entry.element.removeAttribute('data-chicchok-autopopup-suppressed');
    });

    suppressedElements = [];
  }

  function closeShopifyInbox() {
    var chat = document.getElementById('ShopifyChat');

    if (!chat || !chat.shadowRoot) {
      return;
    }

    var toggle = chat.shadowRoot.querySelector('[data-spec="toggle-button"], .chat-toggle');

    if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
      closingInbox = true;

      try {
        toggle.click();
      } finally {
        closingInbox = false;
      }
    }
  }

  function isWidgetPanel(element) {
    if (!element || hasIgnoredAncestor(element) || element.getAttribute('data-chicchok-autopopup-suppressed') === 'true') {
      return false;
    }

    var identity = [
      element.tagName || '',
      element.id || '',
      element.className || '',
      element.getAttribute('src') || '',
      element.getAttribute('title') || '',
      element.getAttribute('aria-label') || ''
    ].join(' ');
    if (!/(smile|salesmartly|shopify.?chat|inbox|loyalty|reward|chat)/i.test(identity)) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();

      if (!/(Binding is freedom|Shipping & Delivery|Order Tracking|Craftsmanship|Size & Material|Speak to Creator|navigate our studio)/i.test(text)) {
        return false;
      }
    }

    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    var isPanelSize = rect.width > 110 && rect.height > 110;
    var isFloating = style.position === 'fixed' || style.position === 'absolute' || Number(style.zIndex) > 1000;

    return isPanelSize && isFloating;
  }

  function suppressElement(element) {
    if (!element || element.getAttribute('data-chicchok-autopopup-suppressed') === 'true') {
      return;
    }

    suppressedElements.push({
      element: element,
      displayValue: element.style.display,
      displayPriority: element.style.getPropertyPriority('display'),
      visibilityValue: element.style.visibility,
      visibilityPriority: element.style.getPropertyPriority('visibility')
    });

    element.setAttribute('data-chicchok-autopopup-suppressed', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
  }

  function collectCandidates(root) {
    if (!root || root.nodeType !== 1 || !root.isConnected || hasIgnoredAncestor(root)) {
      return;
    }

    if (matches(root, candidateSelector)) {
      candidates.add(root);
    }

    root.querySelectorAll(candidateSelector).forEach(function (element) {
      if (!hasIgnoredAncestor(element)) {
        candidates.add(element);
      }
    });
  }

  function suppressAutoOpenedPanels() {
    scheduledFrame = null;

    if (userOpenedWidget || document.hidden) {
      return;
    }

    pendingRoots.forEach(collectCandidates);
    pendingRoots.clear();
    closeShopifyInbox();
    var panels = [];

    candidates.forEach(function (element) {
      if (!element.isConnected) {
        candidates.delete(element);
        return;
      }

      if (isWidgetPanel(element)) {
        panels.push(element);
      }
    });

    panels.forEach(suppressElement);
  }

  function scheduleSuppression(root) {
    if (userOpenedWidget) {
      return;
    }

    if (root && root.nodeType === 1) {
      pendingRoots.add(root);
    }

    if (scheduledFrame !== null || document.hidden) {
      return;
    }

    scheduledFrame = window.requestAnimationFrame(suppressAutoOpenedPanels);
  }

  function discoverWidgets() {
    scheduleSuppression(document.body);
  }

  document.addEventListener('pointerdown', markUserOpened, true);
  document.addEventListener('click', markUserOpened, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', discoverWidgets, { once: true });
  } else {
    discoverWidgets();
  }

  window.addEventListener('load', function () {
    scheduleSuppression();
  }, { once: true });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        if (mutation.target.nodeType === 1 && (candidates.has(mutation.target) || matches(mutation.target, candidateSelector))) {
          scheduleSuppression(mutation.target);
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scheduleSuppression(node);
          }
        });
        return;
      }

      var target = mutation.target;

      if (target.getAttribute('data-chicchok-autopopup-suppressed') === 'true') {
        return;
      }

      if (candidates.has(target) || matches(target, candidateSelector)) {
        scheduleSuppression(target);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'aria-expanded']
  });

  [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
    retryTimers.push(window.setTimeout(function () {
      scheduleSuppression();
    }, delay));
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && scheduledFrame !== null) {
      window.cancelAnimationFrame(scheduledFrame);
      scheduledFrame = null;
    } else if (!document.hidden) {
      scheduleSuppression();
    }
  });
})();
